import { render, staticRenderFns } from "./CustomizeEvent.vue?vue&type=template&id=1b0e6025"
import script from "./CustomizeEvent.vue?vue&type=script&lang=js"
export * from "./CustomizeEvent.vue?vue&type=script&lang=js"
import style0 from "./CustomizeEvent.vue?vue&type=style&index=0&id=1b0e6025&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports